const tags = {
  slug: 'f/tags',
  getTag: slug => `${tags.slug}/${slug}`,
  tagsQuickSearch: () => `${tags.slug}/search/quick`,
  tagsFullSearch: () => `${tags.slug}/search/full`
}

export default tags
